// extracted by mini-css-extract-plugin
module.exports = {"settings":"KanBoListSettings_settings__ypIBW"};